module.exports = __webpack_public_path__ + "static/media/Za_cihelnou.bce979b5.md";